export default "__VITE_ASSET__c95d38fc__"